<template>
    <label>
        <slot/>
    </label>
</template>
<script>
export default {}
</script>
